import { useMemo } from 'react';
import { IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';

const ActionIconButton = styled(IconButton, {
	shouldForwardProp: (prop) => !['prop', 'shape', 'variant'].includes(prop)
})(({ theme, color, variant = 'text', shape = 'round'}) => {
	const colorStyles = useMemo(() => {
		let color1 = color;
		let color2 = color;
		let color3 = theme.palette.primary.contrastText;
		let sx = {};
		if (color in theme.palette) {
			color1 = theme.palette[color]?.main || theme.palette[color];
			color2 = theme.palette[color]?.dark || color1;
		}
		if (variant === 'outlined') {
			color3 = color1;
			sx = {
				color: color1,
				border: `1px solid ${color1}`,
				'&:hover': {
					color: color2,
					borderColor: color2,
					border: `1px solid ${color2}`,
				},
				'&:focus': {
					color: color2,
					borderColor: color2
				}
			};
		} else if (variant === 'contained') {
			sx = {
				backgroundColor: color1,
				color: color3,
				'&:hover': {
					backgroundColor: color2
				},
				'&:focus': {
					backgroundColor: color2
				}
			};
		} else {
			sx = {
				color: color1,
				'&:hover': {
					color: color2
				},
				'&:focus': {
					color: color2
				}
			};
		}

		return sx;
	}, [color, theme.palette, variant]);
	let shapeStyles = { borderRadius: theme.shape.borderRadius };

	switch (shape) {
		case 'circle':
			shapeStyles = { borderRadius: 99999 };
			break;
		case 'square':
			shapeStyles = { borderRadius: 0 };
			break;
		case 'squircle':
			shapeStyles = { position: 'relative', borderRadius: 0 };
			break;
		default:
			shapeStyles = { borderRadius: theme.shape.borderRadius };
			break;
	}
	return {
		...shapeStyles,
		...colorStyles
	};
});


export default ActionIconButton;